import React from "react";
import { ModeRendererProps } from "./types";

// VASARELY × GIVENCHY: Structured grace
// Line purity, silver accents, optical depth
export function VasarelyGivenchyMode({ brand }: ModeRendererProps) {
  const givenchySilver = "#C0C0C0";

  return (
    <g>
      {/* Elegant light background */}
      <defs>
        <linearGradient id="givenchy-elegance" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#F8F8F8" />
          <stop offset="100%" stopColor="#E0E0E0" />
        </linearGradient>
      </defs>

      <rect x="0" y="0" width="794" height="1123" fill="url(#givenchy-elegance)" />

      <g transform="translate(397 540)">
        {/* Line purity grid */}
        {Array.from({ length: 28 }).map((_, i) => {
          const y = -320 + i * 23;
          return (
            <line
              key={`h-${i}`}
              x1="-320"
              y1={y}
              x2="320"
              y2={y}
              stroke={givenchySilver}
              strokeWidth="1"
              opacity="0.3"
            />
          );
        })}
        
        {Array.from({ length: 28 }).map((_, i) => {
          const x = -320 + i * 23;
          return (
            <line
              key={`v-${i}`}
              x1={x}
              y1="-320"
              x2={x}
              y2="320"
              stroke={givenchySilver}
              strokeWidth="1"
              opacity="0.3"
            />
          );
        })}

        {/* Optical depth circles */}
        {Array.from({ length: 16 }).map((_, i) => {
          const r = 30 + i * 16;
          return (
            <circle
              key={i}
              cx="0"
              cy="0"
              r={r}
              fill="none"
              stroke={givenchySilver}
              strokeWidth="2"
              opacity={0.4 - i * 0.02}
            />
          );
        })}

        {/* Silver accent structure */}
        {[-1, 1].map((dir) =>
          Array.from({ length: 8 }).map((_, i) => {
            const x = dir * (60 + i * 25);
            const y = -140 + i * 35;
            
            return (
              <rect
                key={`${dir}-${i}`}
                x={x - 15}
                y={y - 20}
                width="30"
                height="40"
                fill={givenchySilver}
                opacity="0.15"
              />
            );
          })
        )}

        {/* Graceful diagonal lines */}
        {Array.from({ length: 24 }).map((_, i) => {
          const angle = (i * Math.PI) / 12;
          return (
            <line
              key={i}
              x1="0"
              y1="0"
              x2={Math.cos(angle) * 260}
              y2={Math.sin(angle) * 260}
              stroke={givenchySilver}
              strokeWidth="1"
              opacity="0.2"
              strokeDasharray="4 4"
            />
          );
        })}

        {/* Structured grace nodes */}
        {[0, 72, 144, 216, 288].map((angle) => {
          const rad = (angle * Math.PI) / 180;
          const r = 190;
          
          return (
            <g key={angle}>
              <rect
                x={Math.cos(rad) * r - 12}
                y={Math.sin(rad) * r - 12}
                width="24"
                height="24"
                fill={givenchySilver}
                opacity="0.4"
              />
              <rect
                x={Math.cos(rad) * r - 12}
                y={Math.sin(rad) * r - 12}
                width="24"
                height="24"
                fill="none"
                stroke={brand.black}
                strokeWidth="2"
                opacity="0.5"
              />
            </g>
          );
        })}

        {/* Central medallion */}
        <rect x="-60" y="-60" width="120" height="120" fill={givenchySilver} opacity="0.2" />
        <rect x="-60" y="-60" width="120" height="120" fill="none" stroke={givenchySilver} strokeWidth="3" opacity="0.6" />
        
        {/* Four corner accents */}
        {[
          { x: -50, y: -50 },
          { x: 50, y: -50 },
          { x: -50, y: 50 },
          { x: 50, y: 50 },
        ].map((corner, i) => (
          <circle
            key={i}
            cx={corner.x}
            cy={corner.y}
            r="6"
            fill={brand.black}
            opacity="0.6"
          />
        ))}
      </g>

      {/* Givenchy inscription */}
      <text x="397" y="1010" textAnchor="middle" fontFamily="serif" fontSize="11" fill="#555" opacity="0.7" fontStyle="italic">
        grâce structurée
      </text>
    </g>
  );
}
